import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class ExchangeDetail {

  // public static ALL: string = "*";
  public static ALL: string = "";
  public static ALL_TEXT: string = "ALL";

  @JsonProperty()
  codeOrigin: string | undefined;

  @JsonProperty()
  code: string | undefined;

  @JsonProperty()
  clearingHouse: string | undefined;

  @JsonProperty()
  description: string | undefined;

  @JsonProperty()
  country: string | undefined;

  @JsonProperty()
  openingHour: number;

  @JsonProperty()
  openingHourDate: Date;

  @JsonProperty()
  closingHour: number;

  @JsonProperty()
  closingHourDate: Date;

  @JsonProperty()
  timeZone: string | undefined;

  @JsonProperty()
  virtual: boolean = true;

  @JsonProperty()
  contractVersion: boolean = false;

  @JsonProperty()
  generateOrder: boolean = false;

  @JsonProperty()
  generateTrade: boolean = false;

  @JsonProperty()
  reversalManagement: boolean = false;

  @JsonProperty()
  apsManagement: boolean = false;

  @JsonProperty()
  changeReferenceCauseClearing: boolean = false;

  @JsonProperty()
  giveupAccountTypeManagement: boolean = false;

  @JsonProperty()
  giveupMessage2Management: boolean = false;

  @JsonProperty()
  openCloseManagement: boolean = false;

  @JsonProperty()
  giveupCommissionAcceptMng: boolean = false;

  @JsonProperty()
  apscustomoverride: boolean = false;
  @JsonProperty()
  taspriceoverride: boolean = false;
  @JsonProperty()
  traderMemoManagement: boolean = false;

  @JsonProperty()
  apsGroupIdRegex: string | undefined;

  @JsonProperty()
  apsExcludeTradeType: string | undefined;

  @JsonProperty()
  updatePriceAllowedTradeTypes: string | undefined;

  @JsonProperty()
  readonly: boolean = false;

  @JsonProperty()
  apsManageByUser: boolean = false;

  @JsonProperty()
  giveinRejection: boolean = false;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

  @JsonProperty()
  enabled: boolean = true;

  @JsonProperty()
  purgedDate: DateTime = DateTime.now();

  @JsonProperty()
  micCode: string | undefined;

  @JsonProperty()
  reversalRejectionManagement: boolean = false;

}
